import { useEffect, useState } from 'react';

import { SimpleModal } from '@labradorsports/components';
import { useSite } from '@labradorsports/utils';

import { ForceError } from '../index.js';

const AboutModal: FC = () => {
    const { Config } = useSite();
    const [open, setOpen] = useState(false);
    const [clickCount, setClickCount] = useState(0);

    useEffect(() => {
        if (!open) {
            setClickCount(0);
        }
    }, [open]);

    useEffect(() => {
        window.addEventListener('keypress', (e) => {
            if (e.key === 'V' && e.ctrlKey) {
                setOpen(true);
            }
        });

        window.addEventListener('about-modal', () => {
            setOpen(true);
        });
    }, []);

    const versionClick = () => {
        setClickCount(clickCount + 1);
    };

    const targetClickCount = PROD ? 10 : 1;

    return (
        <SimpleModal onClose={() => setOpen(false)} open={open}>
            <p>{Config.SiteConfig.SiteName}</p>
            <p onClick={versionClick}>
                Version: {VERSION}-{BUILD}
            </p>

            {clickCount >= targetClickCount ? <ForceError /> : null}
        </SimpleModal>
    );
};

export default AboutModal;
